import Axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { createAction } from 'redux-act';
import { url } from 'utils/url';
import { log, errorMsg } from 'utils';

export const PRODUCT_CATEGORIES_FETCH_DATA_INIT = createAction(
  'PRODUCT_CATEGORIES_FETCH_DATA_INIT'
);
export const PRODUCT_CATEGORIES_FETCH_DATA_SUCCESS = createAction(
  'PRODUCT_CATEGORIES_FETCH_DATA_SUCCESS'
);
export const PRODUCT_CATEGORIES_FETCH_DATA_FAIL = createAction(
  'PRODUCT_CATEGORIES_FETCH_DATA_FAIL'
);

export const PRODUCT_SUB_CATEGORIES_FETCH_DATA_INIT = createAction(
  'PRODUCT_SUB_CATEGORIES_FETCH_DATA_INIT'
);
export const PRODUCT_SUB_CATEGORIES_FETCH_DATA_SUCCESS = createAction(
  'PRODUCT_SUB_CATEGORIES_FETCH_DATA_SUCCESS'
);
export const PRODUCT_SUB_CATEGORIES_FETCH_DATA_FAIL = createAction(
  'PRODUCT_SUB_CATEGORIES_FETCH_DATA_FAIL'
);

export const PRODUCT_CATEGORIES_DELETE_CATEGORY_INIT = createAction(
  'PRODUCT_CATEGORIES_DELETE_CATEGORY_INIT'
);
export const PRODUCT_CATEGORIES_DELETE_CATEGORY_SUCCESS = createAction(
  'PRODUCT_CATEGORIES_DELETE_CATEGORY_SUCCESS'
);
export const PRODUCT_CATEGORIES_DELETE_CATEGORY_FAIL = createAction(
  'PRODUCT_CATEGORIES_DELETE_CATEGORY_FAIL'
);

export const PRODUCT_CATEGORIES_CLEAR_DATA = createAction(
  'PRODUCT_CATEGORIES_CLEAR_DATA'
);

export const PRODUCT_CATEGORIES_CREATE_CATEGORY_INIT = createAction(
  'PRODUCT_CATEGORIES_CREATE_CATEGORY_INIT'
);
export const PRODUCT_CATEGORIES_CREATE_CATEGORY_SUCCESS = createAction(
  'PRODUCT_CATEGORIES_CREATE_CATEGORY_SUCCESS'
);
export const PRODUCT_CATEGORIES_CREATE_CATEGORY_FAIL = createAction(
  'PRODUCT_CATEGORIES_CREATE_CATEGORY_FAIL'
);

export const PRODUCT_CATEGORIES_MODIFY_CATEGORY_INIT = createAction(
  'PRODUCT_CATEGORIES_MODIFY_CATEGORY_INIT'
);
export const PRODUCT_CATEGORIES_MODIFY_CATEGORY_SUCCESS = createAction(
  'PRODUCT_CATEGORIES_MODIFY_CATEGORY_SUCCESS'
);
export const PRODUCT_CATEGORIES_MODIFY_CATEGORY_FAIL = createAction(
  'PRODUCT_CATEGORIES_MODIFY_CATEGORY_FAIL'
);

export const PRODUCT_CATEGORIES_CLEAN_UP = createAction(
  'PRODUCT_CATEGORIES_CLEAN_UP'
);

export const PRODUCT_CATEGORIES_CLEAR_DATA_LOGOUT = createAction(
  'PRODUCT_CATEGORIES_CLEAR_DATA_LOGOUT'
);

export const SET_PRODUCT_CATEGORY = createAction('SET_PRODUCT_CATEGORY');

export const PRODUCT_SUB_CATEGORIES_CREATE_CATEGORY_INIT = createAction(
  'PRODUCT_SUB_CATEGORIES_CREATE_CATEGORY_INIT'
);
export const PRODUCT_SUB_CATEGORIES_CREATE_CATEGORY_SUCCESS = createAction(
  'PRODUCT_SUB_CATEGORIES_CREATE_CATEGORY_SUCCESS'
);
export const PRODUCT_SUB_CATEGORIES_CREATE_CATEGORY_FAIL = createAction(
  'PRODUCT_SUB_CATEGORIES_CREATE_CATEGORY_FAIL'
);

export const PRODUCT_SUB_CATEGORIES_MODIFY_CATEGORY_INIT = createAction(
  'PRODUCT_SUB_CATEGORIES_MODIFY_CATEGORY_INIT'
);
export const PRODUCT_SUB_CATEGORIES_MODIFY_CATEGORY_SUCCESS = createAction(
  'PRODUCT_SUB_CATEGORIES_MODIFY_CATEGORY_SUCCESS'
);
export const PRODUCT_SUB_CATEGORIES_MODIFY_CATEGORY_FAIL = createAction(
  'PRODUCT_SUB_CATEGORIES_MODIFY_CATEGORY_FAIL'
);

export const fetchProductCategories = ({ siteId }) => {
  return async (dispatch, getState) => {
    dispatch(PRODUCT_CATEGORIES_FETCH_DATA_INIT());
    if (siteId) {
      let categories;
      try {
        categories = await Axios.get(`${url}/product/category/${siteId}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        });
      } catch (error) {
        toastr.error('', `${errorMsg(dispatch, error)}`);
        return dispatch(PRODUCT_CATEGORIES_FETCH_DATA_FAIL({ error }));
      }
      categories = categories.data.data.filter(
        (category) => category.siteId === siteId
      );

      return dispatch(
        PRODUCT_CATEGORIES_FETCH_DATA_SUCCESS({
          list: categories,
          category: getState().categories.category,
        })
      );
    }
  };
};

export const deleteCategory = (id, siteId, cb) => {
  return async (dispatch) => {
    dispatch(PRODUCT_CATEGORIES_DELETE_CATEGORY_INIT());

    try {
      await Axios.delete(`${url}/poiCategory/delete`, {
        params: {
          id,
          siteId,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage, { icon: 'error' });
      return dispatch(
        PRODUCT_CATEGORIES_DELETE_CATEGORY_FAIL({
          error: errorMessage,
        })
      );
    }

    toastr.success('', 'The category was deleted.');
    cb();
    return dispatch(PRODUCT_CATEGORIES_DELETE_CATEGORY_SUCCESS({ id }));
  };
};

export const clearCategoriesData = () => {
  return (dispatch) => {
    dispatch(PRODUCT_CATEGORIES_CLEAR_DATA());
  };
};

export const clearCategoriesDataLogout = () => {
  return (dispatch) => {
    dispatch(PRODUCT_CATEGORIES_CLEAR_DATA_LOGOUT());
  };
};

export const createProductCategory = (
  { name, description, siteId, file, userId },
  cb
) => {
  return async (dispatch) => {
    dispatch(PRODUCT_CATEGORIES_CREATE_CATEGORY_INIT());
    let category;
    try {
      const categoryData = new FormData();
      categoryData.set('name', name);
      categoryData.set('description', description);
      categoryData.set('siteId', siteId);
      categoryData.append('userId', userId);
      if (file) categoryData.append('file', file);

      category = await Axios.post(
        `${url}/product/category/create`,
        categoryData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
    } catch (error) {
      log(error.response, '<<< error response');
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        PRODUCT_CATEGORIES_CREATE_CATEGORY_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }
    toastr.success('', 'Category created successfully');
    cb();
    dispatch(
      SET_PRODUCT_CATEGORY({
        data: {
          name: '',
          description: '',
        },
      })
    );

    return dispatch(
      PRODUCT_CATEGORIES_CREATE_CATEGORY_SUCCESS({
        category: category.data.data,
      })
    );
  };
};

export const modifyProductCategory = (
  { id, name, description, logo, file, siteId, modifiedAt, modifiedBy, userId },
  cb
) => {
  return async (dispatch) => {
    dispatch(PRODUCT_CATEGORIES_MODIFY_CATEGORY_INIT());

    const categoryData = new FormData();
    categoryData.set('id', id);
    categoryData.set('name', name);
    categoryData.set('description', description);
    categoryData.set('siteId', siteId);
    categoryData.append('userId', userId);
    categoryData.set('modifiedAt', modifiedAt);
    categoryData.set('modifiedBy', modifiedBy);
    if (logo) categoryData.set('logo', logo);
    if (file) categoryData.append('file', file);

    let updateCategoryDbTask;
    try {
      updateCategoryDbTask = await Axios.put(
        `${url}/product/category/update/${id}`,
        categoryData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
      // await Promise.all([updateCategoryDbTask]);
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);

      return dispatch(
        PRODUCT_CATEGORIES_MODIFY_CATEGORY_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }

    toastr.success('', 'Category updated successfully');
    cb();
    dispatch(
      SET_PRODUCT_CATEGORY({
        data: {
          name: '',
          description: '',
        },
      })
    );
    return dispatch(
      PRODUCT_CATEGORIES_MODIFY_CATEGORY_SUCCESS({
        category: updateCategoryDbTask.data.data,
        id,
      })
    );
  };
};

export const setCategory = (data, cb) => {
  return (dispatch) => {
    dispatch(SET_PRODUCT_CATEGORY({ data }));
    if (cb) {
      cb();
    }
  };
};

export const fetchProductSubCategories = ({ siteId, categoryId }) => {
  return async (dispatch, getState) => {
    dispatch(PRODUCT_SUB_CATEGORIES_FETCH_DATA_INIT());
    if (siteId) {
      let categories;
      try {
        categories = await Axios.get(
          `${url}/product/subcategory/list/${siteId}/${categoryId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            },
          }
        );
      } catch (error) {
        toastr.error('', `${errorMsg(dispatch, error)}`);
        return dispatch(PRODUCT_SUB_CATEGORIES_FETCH_DATA_FAIL({ error }));
      }
      categories = categories.data.data.filter(
        (category) => category.siteId === siteId
      );

      return dispatch(
        PRODUCT_SUB_CATEGORIES_FETCH_DATA_SUCCESS({
          list: categories,
        })
      );
    }
  };
};

export const createProductSubCategory = (
  { name, description, siteId, file, userId, categoryId },
  cb
) => {
  return async (dispatch) => {
    dispatch(PRODUCT_SUB_CATEGORIES_CREATE_CATEGORY_INIT());
    let category;
    try {
      const categoryData = new FormData();
      categoryData.set('name', name);
      categoryData.set('description', description);
      categoryData.set('siteId', siteId);
      categoryData.append('userId', userId);
      categoryData.append('categoryId', categoryId);
      if (file) categoryData.append('file', file);

      category = await Axios.post(
        `${url}/product/subcategory/create`,
        categoryData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
    } catch (error) {
      log(error.response, '<<< error response');
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        PRODUCT_SUB_CATEGORIES_CREATE_CATEGORY_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }
    toastr.success('', 'Category created successfully');
    cb();

    return dispatch(
      PRODUCT_SUB_CATEGORIES_CREATE_CATEGORY_SUCCESS({
        category: category.data.data,
      })
    );
  };
};

export const modifyProductSubCategory = (
  {
    id,
    name,
    description,
    logo,
    file,
    siteId,
    modifiedAt,
    modifiedBy,
    userId,
    categoryId,
  },
  cb
) => {
  return async (dispatch) => {
    dispatch(PRODUCT_SUB_CATEGORIES_MODIFY_CATEGORY_INIT());

    const categoryData = new FormData();
    categoryData.set('name', name);
    categoryData.set('description', description);
    categoryData.set('siteId', siteId);
    categoryData.append('userId', userId);
    categoryData.set('modifiedAt', modifiedAt);
    categoryData.set('modifiedBy', modifiedBy);
    categoryData.set('categoryId', categoryId);
    if (logo) categoryData.set('logo', logo);
    if (file) categoryData.append('file', file);

    let updateCategoryDbTask;
    try {
      updateCategoryDbTask = await Axios.put(
        `${url}/product/subcategory/update/${id}`,
        categoryData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
      // await Promise.all([updateCategoryDbTask]);
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);

      return dispatch(
        PRODUCT_SUB_CATEGORIES_MODIFY_CATEGORY_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }

    toastr.success('', 'Category updated successfully');
    cb();

    return dispatch(
      PRODUCT_SUB_CATEGORIES_MODIFY_CATEGORY_SUCCESS({
        category: updateCategoryDbTask.data.data,
        id,
      })
    );
  };
};
